export function LanguageOutline({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.91052 5.2266H4.08887M6.99984 4.24679V5.22678M8.45817 5.2151C8.45817 7.72344 6.49817 9.75342 4.08317 9.75342M9.91661 9.75328C8.86661 9.75328 7.93328 9.19329 7.26245 8.31246M5.24984 12.8333H8.74984C11.6665 12.8333 12.8332 11.6666 12.8332 8.74996V5.24996C12.8332 2.33329 11.6665 1.16663 8.74984 1.16663H5.24984C2.33317 1.16663 1.1665 2.33329 1.1665 5.24996V8.74996C1.1665 11.6666 2.33317 12.8333 5.24984 12.8333Z"
          stroke="currentColor"
          strokeWidth="1.05"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
